import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import {
  List, ListItemButton, ListItemIcon, ListItemText, Typography,
} from '@mui/material';
import { LoadIcon, PrintIcon } from '../Styled/Buttons/icons';
import { AppContext } from '../../providers/authProvider';

const services = [
  {
    title: 'Перезаповнити контракти',
    desc: 'Використовується для автоматичного заповнення контрактів',
    icon: LoadIcon,
    url: '/srv/reload_contracts/',
    section: 'reload_contract',
  },
  {
    title: 'Перезаповнити платників з примітки',
    desc: 'Використовується для автоматичного перезаповненя платнків з коду ІНН в примітці (Транзитний рахунок)',
    icon: LoadIcon,
    url: '/srv/parse-comments/',
    section: 'service_parse_comments',
  },
  {
    title: 'Перезаповнити гендерні ознаки платників',
    desc: 'Використовується для автоматичного перезаповненя статті, признаку юр особи, дати народження и т.і.',
    icon: LoadIcon,
    url: '/srv/parse-payers/',
    section: 'service_parse_payer_code',
  },
  {
    title: 'Надіслати повідомлення користувачам',
    desc: 'Використовується для відправлення повідомлення користувачам',
    icon: LoadIcon,
    url: '/srv/send-message/',
    onlyForAdmins: true,
  },
  {
    title: 'Замінити платника',
    desc: 'Замніна одного платника на іншого. Викристовуються у випадку дублювання плантиків',
    icon: LoadIcon,
    url: '/srv/unite-payers/',
    onlyForAdmins: true,
  },
  {
    title: 'Розширена обробка даних',
    desc: '',
    icon: LoadIcon,
    url: '/srv/master/',
    section: 'service_master',
  },
  {
    title: 'Обробка зауважень',
    desc: '',
    icon: LoadIcon,
    url: '/srv/remarks-processing/',
    section: 'service_warnings',
  },
  {
    title: 'Мастер СКД',
    desc: '',
    icon: LoadIcon,
    url: '/srv/skd-master/',
    onlyForAdmins: true,
  },
  {
    title: 'Управління Ролями',
    desc: '',
    icon: LoadIcon,
    url: '/srv/role_management/',
    onlyForAdmins: true,
  },
  {
    title: 'Управління Групами',
    desc: '',
    icon: LoadIcon,
    url: '/srv/group_management/',
    onlyForAdmins: true,
  },
  {
    title: 'Виключення КДБ',
    desc: '',
    icon: LoadIcon,
    url: '/srv/disabled_kdb/',
  },
  {
    title: 'Розрахунок індексації орендної плати',
    desc: '',
    icon: LoadIcon,
    url: '/srv/indexing_contracts/',
  },
  {
    title: 'Друк рахунків за оренду комунального майна',
    desc: '',
    icon: PrintIcon,
    url: '/srv/print_invoices/',
  },
  {
    title: 'Завантаження даних за боржниками з файлу у форматі Excel',
    desc: '',
    icon: LoadIcon,
    url: '/srv/load_debts/',
  },
];
function ServicePage() {
  const { currentUser } = useContext(AppContext);
  return (
    <>
      <Typography variant="h5">
        Сервіс
      </Typography>
      <List sx={{ display: 'flex', flexWrap: 'wrap', gap: 3 }}>
        {services
          .filter((s) => (!s.onlyForAdmins || currentUser.is_superuser)
          && (!s.section || currentUser.available_sections.includes(s.section)))
          .map((s) => (
            <ListItemButton
              component={Link}
              key={s.url}
              to={s.url}
              sx={{ border: 1, borderColor: 'grey.300', borderRadius: 2 }}
            >
              <ListItemIcon sx={{ height: 40 }}>
                <img src={s.icon} alt="menu" />
              </ListItemIcon>
              <ListItemText>{s.title}</ListItemText>
            </ListItemButton>
          ))}
      </List>
    </>
  );
}

ServicePage.propTypes = {
};
export default ServicePage;
